import React from "react";
import { Link } from "react-router-dom";

// CSS
import "./header.css";

// Icon
import { FaCartShopping } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";

// Components
import CompanyLogo from "../CompanyLogo/CompanyLogo";

const Header = () => {
  return (
    <header className="header">
      <div className="header-container">
        <CompanyLogo />
        <nav className="nav">
          <ul className="nav-links">
            <li className="nav-link">
              <Link to="/">Home</Link>
            </li>
            <li className="nav-link">
              <Link to="/menu">Menu</Link>
            </li>
            <li className="nav-link">
              <Link to="/custom">Iftar</Link>
            </li>
            <a href="tel:+8801521494760" className="nav-cta btn btn-primary">
              <FaPhoneAlt className="nav-phone-icon" />
            </a>
            <Link className="nav-cta btn btn-secondary" to="/order">
              <FaCartShopping className="nav-cart-icon" />
            </Link>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
